export default __webpack_public_path__ + "static/media/stripe-external-link.1f039d69.svg";